module.exports = __webpack_public_path__ + "static/media/KaTeX_Size3-Regular.882f7234.ttf";